import { surfaces } from '@ui/kit';
import { combineTokens } from '@utils/css';

combineTokens("--uui-lightbox-card", {
  badgeSurface: surfaces.accent.default
});
const wrapperCls = "_araw1vw7w71";
const icon = "_araikyutgi";

export { icon, wrapperCls };
import "./error.card.style.linaria.module.css";
//# sourceMappingURL=error.card.style.js.map
